var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "main-sidebar"]
var hoisted2 = ["class", "sidebar"]
var hoisted3 = ["class", "sidebar-form"]
var hoisted4 = ["class", "input-group"]
var hoisted5 = ["type", "text", "name", "q", "class", "form-control", "placeholder", "Search...", "autocomplete", "off"]
var hoisted6 = ["class", "input-group-btn"]
var hoisted7 = ["type", "submit", "name", "search", "id", "search-btn", "class", "btn btn-flat"]
var hoisted8 = ["class", "fa fa-search"]
var hoisted9 = ["class", "sidebar-menu"]
var hoisted10 = ["class", "file"]
var hoisted11 = ["class", "header", "style", "text-transform: uppercase;"]
var hoisted12 = ["class", "treeview active open-editors"]
var hoisted13 = ["href", "#"]
var hoisted14 = ["class", "fa fa-dashboard"]
var hoisted15 = ["class", "pull-right-container"]
var hoisted16 = ["class", "fa fa-angle-left pull-right"]
var hoisted17 = ["class", "treeview-menu menu-open"]
var hoisted18 = ["class", "clear pull-right"]
var hoisted19 = ["class", "file"]
var hoisted20 = ["class", "text-danger"]
var hoisted21 = ["class", "pull-right-container"]
var hoisted22 = ["class", "fa fa-angle-left pull-right"]
var hoisted23 = ["class", "treeview-menu"]
var hoisted24 = ["class", "fa fa-circle-o"]
var __target

module.exports = function description (ctrl) {
  elementOpen("aside", "3ba8a11f-b728-45bb-a030-1eed3c5dd2a2", hoisted1)
    elementOpen("section", "b25efdfb-d8f8-4421-aad5-022daf2f0778", hoisted2)
      elementOpen("form", "6f229829-d66a-4862-adb4-812f967e4d10", hoisted3, "onsubmit", function ($event) {
        var $element = this;
      ctrl.query = this.q.value})
        elementOpen("div", "ec92d943-5250-4810-bc35-767dae72223f", hoisted4)
          elementOpen("input", "cf10528d-8d90-4e56-9249-9f322f845dfb", hoisted5, "onkeyup", function ($event) {
            var $element = this;
          ctrl.query = this.value})
          elementClose("input")
          elementOpen("span", "94584edf-47cb-4240-a997-10441c71b660", hoisted6)
            elementOpen("button", "912811ac-bd31-4664-80a5-ce4b22428d3a", hoisted7)
              elementOpen("i", "48370fe6-89b4-4f7e-8c46-fc857a3f1fa0", hoisted8)
              elementClose("i")
            elementClose("button")
          elementClose("span")
        elementClose("div")
      elementClose("form")
      elementOpen("ul", "6cbeb7f1-d379-4325-a91b-9b7178ea9395", hoisted9)
        if (ctrl.query) {
          var results = ctrl.searchFiles()
          __target = results
          if (__target) {
            ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
              var result = $value
              var $key = "1b09b84a-4357-485d-82d3-b1f646254467_" + $item
              elementOpen("li", $key)
                elementOpen("a", "88b7b2ee-a867-4bc1-988b-4895ab885e04_" + $key, hoisted10, "onclick", function ($event) {
                  var $element = this;
                ctrl.main.setCurrentFile(result)})
                  elementOpen("span")
                    text("" + (result.getDisplayName()) + "")
                  elementClose("span")
                elementClose("a")
              elementClose("li")
            }, this)
          }
        }
        elementOpen("li", "95ecc987-41f9-4e1d-a740-31fc6eed4e08", hoisted11)
          text("" + (ctrl.name) + "")
        elementClose("li")
        elementOpen("li", "36941a2e-9b2e-4a36-95ce-47d71de3d67a", hoisted12)
          var recent = ctrl.main.recent
                      // var items = recent.items
                      // var dirty = recent.dirty()
          elementOpen("a", "5b420672-3906-49f7-868f-e87ae0f4429c", hoisted13)
            elementOpen("i", "36b37bf6-960e-442f-9ba4-261d90d0dd1b", hoisted14)
            elementClose("i")
            elementOpen("span")
              text(" \
                            Open editors (" + (recent.length) + ") \
                            ")
            elementClose("span")
            elementOpen("span", "9a5bf2f9-fd56-49d7-9be4-8875305dcf85", hoisted15)
              elementOpen("i", "2d54e07e-6780-4d88-8278-dd43cead88cf", hoisted16)
              elementClose("i")
            elementClose("span")
          elementClose("a")
          elementOpen("ul", "e3f123bb-2672-4fdd-b71f-57662f2cd4f6", hoisted17)
            __target = recent
            if (__target) {
              ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
                var item = $value
                var $key = "1299ab13-b187-46d4-b865-a96803f25802_" + item.path
                elementOpen("li", $key, null, "class", item === ctrl.main.current ? 'active' : '')
                  elementOpen("a", "c60bbed4-68fa-478b-abdd-f70eb4ed45c5_" + $key, hoisted18, "onclick", function ($event) {
                    var $element = this;
                  ctrl.main.closeFile(item)})
                    text("×")
                  elementClose("a")
                  elementOpen("a", "7632954e-be1d-4cce-b3f9-1ec149aabc39_" + $key, hoisted19, "onclick", function ($event) {
                    var $element = this;
                  ctrl.main.setCurrentFile(item)})
                    text(" \
                                    " + (item.getDisplayName()) + " \
                                    ")
                    if (item.session && item.session.isDirty) {
                      elementOpen("span", "b3e81ff8-db4e-4d4b-9fc8-81800f4c2a66_" + $key, hoisted20)
                        text("*")
                      elementClose("span")
                    }
                  elementClose("a")
                elementClose("li")
              }, this)
            }
          elementClose("ul")
        elementClose("li")
        __target = ctrl.getLinks()
        if (__target) {
          ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
            var link = $value
            var $key = "4f133d41-5ed9-4fee-8d36-a128f7540ccd_" + $item
            elementOpen("li", $key, null, "class", link.children ? 'treeview' : '')
              if (link.children) {
                elementOpen("a")
                  elementOpen("i", null, null, "class", "fa fa-" + (link.icon) + "")
                  elementClose("i")
                  elementOpen("span")
                    text("" + (link.text) + "")
                  elementClose("span")
                  elementOpen("span", "8fcbb236-f4c4-4f2f-8509-5e7be5259b0f_" + $key, hoisted21)
                    elementOpen("i", "baa4788e-f7c4-4372-a9f1-5436654858a2_" + $key, hoisted22)
                    elementClose("i")
                  elementClose("span")
                elementClose("a")
                elementOpen("ul", "23a54690-c5aa-4b63-b67a-8eeed06d5935_" + $key, hoisted23)
                  __target = link.children
                  if (__target) {
                    ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
                      var child = $value
                      var $key = "1695a065-3bf3-4a43-ab88-a9fa2445cec9_" + child.file.path
                      elementOpen("li", $key)
                        elementOpen("a", null, null, "onclick", function ($event) {
                          var $element = this;
                        ctrl.main.setCurrentFile(child.file)})
                          elementOpen("i", "b6a576ad-fd98-415d-a75a-fda7244e49fe_" + $key, hoisted24)
                          elementClose("i")
                          text(" " + (child.text) + "")
                        elementClose("a")
                      elementClose("li")
                    }, this)
                  }
                elementClose("ul")
              } else {
                elementOpen("a", null, null, "onclick", function ($event) {
                  var $element = this;
                ctrl.main.setCurrentFile(link.file)})
                  elementOpen("i", null, null, "class", "fa fa-" + (link.icon) + "")
                  elementClose("i")
                  elementOpen("span")
                    text("" + (link.text) + "")
                  elementClose("span")
                elementClose("a")
              }
            elementClose("li")
          }, this)
        }
      elementClose("ul")
    elementClose("section")
  elementClose("aside")
}
